import { Markup as InterweaveMarkup, MarkupProps as InterweaveMarkupProps } from 'interweave';
import React from 'react';

import { ExternalLink } from '../Link/Link';
import { Typography, TypographyProps } from '../Typography/Typography';

interface MarkupProps extends InterweaveMarkupProps {
  typographyProps?: Omit<TypographyProps, 'text' | 'children'>;
}

export const Markup = (props: MarkupProps) => {
  const { typographyProps, ...markupProps } = props;

  return (
    <Typography {...typographyProps}>
      <InterweaveMarkup
        {...markupProps}
        transform={(node, children) => {
          if (node.tagName === 'A') {
            const href = node.getAttribute('href');
            // TODO - soon enough we are NOT going to want to support this. And if we do, we can more gracefully handle no href
            return href ? (
              <ExternalLink href={href}>{children}</ExternalLink>
            ) : (
              <a target='_blank'>Invalid Link: missing href</a>
            );
          }
          return undefined;
        }}
      />
    </Typography>
  );
};
